import { render, staticRenderFns } from "./ModalOrderService.vue?vue&type=template&id=3605adc2&"
import script from "./ModalOrderService.vue?vue&type=script&lang=js&"
export * from "./ModalOrderService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports